import QRCode from 'qrcode';

// Debugmodus viser utskrifter i siden uten å skrive ut
const debug = false;

// Skriv ut ordre og kvittering
export function printOrdre(params, isCopy = false) {
    if (debug) {
        console.log('printOrdre params', params);
    }
    const harSal = !!params.forestillinginfo.sal;
    generateOrdreQRs(params).then(
        ok => {
            let tickets = params.ordre.billetter.map( billett => {
                let prisEllerType;
                if (billett.billetttype === 'normal') {
                    prisEllerType = billett.belop + 'kr';
                } else {
                    if (billett.kampanjebeskrivelse) {
                        prisEllerType = billett.kampanjebeskrivelse;
                    } else {
                        prisEllerType = fmtProduktnavn(billett.billetttype).toUpperCase();
                    }
                }
                return markupTicket(
                    params.forestillinginfo.film_tittel,
                    params.forestillinginfo.spillested_tittel,
                    fmtDate(params.forestillinginfo.dato) + ' ' + params.forestillinginfo.tidspunkt,
                    harSal ? (billett.plasstxt || 'Unummerert') : null,
                    prisEllerType,
                    billett.qrSVG,
                    fmtUUID(billett.uuid),
                    isCopy
                )
            });
            tickets = tickets.concat(params.ordre.gavekort.map(gavekort => markupGiftcard(
                gavekort.qrSVG,
                fmtUUID(gavekort.uuid),
                gavekort.verdi,
                fmtDateTime(gavekort.gyldig_ts),
                isCopy
            )));
            const recieptHTML = markupReciept(params, isCopy);
            // Separat kvittering ved fakturabetaling og kjøp av gavekort
            const fakturaTrans = params.ordre.trans.find( t => t.betalingstype === 'faktura' && !t.er_korrigert && !t.er_korreksjon );
            const separateReceipt = !!(fakturaTrans || params.ordre.gavekort.length);
            if (separateReceipt) {
                print(markupPage(recieptHTML));
                if (!fakturaTrans || params.ordre.gavekort.length || (fakturaTrans.betaling_info && !fakturaTrans.betaling_info.skip_billett_print)) {
                    for (let ticket of tickets) {
                        print(markupPage(ticket));
                    }
                }
            } else if (tickets.length === 1) {
                print(markupPage(tickets[0] + '\n' + recieptHTML));
            } else {
                for (let ticket of tickets.slice(0, -1)) {
                    print(markupPage(ticket));
                }
                print(markupPage(tickets[tickets.length - 1] + '\n' + recieptHTML));
            }
        }
    ).catch(
        err => console.error(err)
    );
}

/* Skriv ut alle gyldige billetter i en ordre - uten kvittering */
export function printBilletterFraOrdre(params, isCopy = false) {
    if (debug) {
        console.log('printBilletterFraOrdre params', params);
    }
    const harSal = !!params.forestillinginfo.sal;
    generateOrdreQRs(params).then(
        ok => {
            let tickets = params.ordre.billetter.map( billett => {
                let prisEllerType;
                if (billett.billetttype === 'normal') {
                    prisEllerType = billett.belop + 'kr';
                } else {
                    if (billett.kampanjebeskrivelse) {
                        prisEllerType = billett.kampanjebeskrivelse;
                    } else {
                        prisEllerType = fmtProduktnavn(billett.billetttype).toUpperCase();
                    }
                }
                return markupTicket(
                    params.forestillinginfo.film_tittel,
                    params.forestillinginfo.spillested_tittel,
                    fmtDate(params.forestillinginfo.dato) + ' ' + params.forestillinginfo.tidspunkt,
                    harSal ? (billett.plasstxt || 'Unummerert') : null,
                    prisEllerType,
                    billett.qrSVG,
                    fmtUUID(billett.uuid),
                    isCopy
                )
            });

            for (let ticket of tickets) {
                print(markupPage(ticket));
            }
        }
    ).catch(
        err => console.error(err)
    );
}


/* Skriv ut tilgodebilletter */
export function printVouchers(billetter, recieptParams) {
    if (debug) {
        console.log('printVouchers billetter', billetter);
    }
    Promise.all(
        billetter.map(
            billett => QRCode.toString(
                billett.uuid,
                /* samme settings som vanlige billetter */
                { type: 'svg', errorCorrectionLevel: 'Q', mode: 'alphanumeric' }
            ).then(
                svg => print(
                    markupPage(markupVoucher(
                        svg,
                        fmtUUID(billett.uuid),
                        fmtDateTime(billett.gyldig_ts),
                        billett.org_verdi + 'kr'
                    ))
                )
            )
        )
    ).then(
        ok => printRefundReciept(recieptParams)
    ).catch(
        err => console.error(err)
    );
}

export function printRefundReciept(params) {
    /* type (cash/tilgodebillett), ordreid, kasseid, date, num_tickets, sum */
    print(markupPage(markupRefundReciept(params)));
}

/* Legg i kø og start utskrift hvis køen var tom */
const queue = [];
let printing = false;
const print = function(htmlDocMarkup) {
    queue.push(htmlDocMarkup);
    if (!printing) printNext();
}
/* Skriv ut første html-dokument i køen via midlertidig iframe
   window.print() gjøres fra html-dokumentet i iframen - afterprint rydder opp */
const printNext = function() {
    printing = true;
    const html = queue.shift();
    const iframe = document.createElement('iframe');
    iframe.src = URL.createObjectURL( new Blob([html], { type: 'text/html' }) );
    const afterprint = () => {
        // fjern iframe og skriv ut neste (hvis det fortsatt ligger noe i køen etter shift())
        iframe.contentWindow.removeEventListener('afterprint', afterprint);
        if (queue.length) {
            setTimeout(printNext, 1);
        } else {
            printing = false;
        }
        if (!debug) {
            document.body.removeChild(iframe);
        }
    }
    document.body.appendChild(iframe);
    iframe.contentWindow.addEventListener('afterprint', afterprint);
}

/* genererer 'qrSVG' på hver billett i ordren og ordren selv */
const qrOptions = {
    type: 'svg',
    errorCorrectionLevel: 'Q',/* L~=7%, M~=15%, Q~=25%, H~=30% */
    mode: 'alphanumeric'/* https://www.npmjs.com/package/qrcode#encoding-modes */
};
let generateOrdreQRs = function (params) {
    // Billetter
    let qrPromises = params.ordre.billetter.map(
        billett => QRCode.toString( billett.uuid, qrOptions ).then(
            svg => billett.qrSVG = svg
        )
    );
    // Gavekort
    qrPromises = qrPromises.concat(params.ordre.gavekort.map(
        gavekort => QRCode.toString( gavekort.uuid, qrOptions ).then(
            svg => gavekort.qrSVG = svg
        )
    ));
    // Ordre
    qrPromises.push(
        QRCode.toString( params.ordre.uuid, qrOptions ).then(
            svg => params.ordre.qrSVG = svg
        )
    )
    return Promise.all(qrPromises);
}

/* Styling og markup (sys sammen på ymse måter) */
const css_page_base = `
    html, body { font-size: 11pt; margin: 0; padding: 0; font-family: sans, sans-serif; }
    @page { margin: 0; margin-bottom: 5mm; }
`;
const css_page_tickets = `${css_page_base}
    body, .ordre-qr, .sentrert { display: flex; flex-direction: column; align-items: center; width: 100%; }
    .qr, svg { max-width: 40%; }
    .bk { font-size: 19pt; }
    .org, .utloper { font-size: 10pt; }
    .movie { font-size: 17pt; margin-top: 0.5em; text-align: center; }
    .datetime { font-size: 13pt; }
    .venue { font-size: 11pt; }
    .priceseat { font-size: 11pt; margin-top: 0.5em }
    .iscopy { font-size: 11pt; }
    .id { font-size: 11pt; }
    .kvittering { font-size: 10pt; width: 100% }
    .kvittering h2 { font-size: 11pt; margin: 0.2em; text-align: center; }
    .kvittering .small { font-size: 10pt; }
    .kvittering, .row.strekover {
        margin-top: 0.2em;
        padding-top: 0.2em;
        border-top: 1pt dashed black;
    }
    tr.strek td {
        border-top: 1pt dashed black;
        height: 1pt;
    }
    .row.luftunder {
        margin-bottom: 0.8em;
    }
    .row.luftover {
        margin-top: 0.8em;
    }
    .kvittering .heading {
        font-size: 8pt;
        font-weight: 700;
        text-transform: uppercase;
    }
    .row {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .row div {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
    }
    .row div:nth-child(2) {
        text-align: right;
    }
`;

let markupPage = function (body = '', style = css_page_tickets) {
    return `<!DOCTYPE html>
<html>
    <head>
        <meta charset="UTF-8">
        <style>${style}</style>
        <script type="text/javascript">
            window.addEventListener('load', function() {
                setTimeout(print, 1);
            });
        </script>
    </head>
    <body>${body}</body>
</html>
`;
}
// vanlig billett
let markupTicket = function (movieName, venueName, dateTime, seatText, priceSeat, qrMarkup, ticketId, isCopy = false) {
    return `
<div class="bk">Bygdekinoen</div>
<div class="org">Org.nr. 933 496 716 MVA</div>
<div class="movie">${movieName}</div>
<div class="datetime">${dateTime}</div>
<div class="venue">${venueName}</div>
<div class="seat">${seatText ? seatText : ''}</div>
<div class="priceseat">${priceSeat}</div>
${(isCopy ? '<div class="iscopy">KOPI</div>' : '')}
${qrMarkup}
<div class="id">${ticketId}</div>
`;
}
// fribillett
let markupVoucher = function (qrMarkup, ticketId, expiresTs, value) {
    return `
<div class="bk">Bygdekinoen</div>
<div class="org">Org.nr. 933 496 716 MVA</div>
<div class="movie">Tilgodebillett</div>
<div class="priceseat">${value}</div>
${qrMarkup}
<div class="id">${ticketId}</div>
<div class="utloper">Gyldig til ${expiresTs}</div>
`;
}

// gavekort
let markupGiftcard = function (qrMarkup, ticketId, verdi, expiresTs) {
    return `
<div class="bk">Bygdekinoen</div>
<div class="org">Org.nr. 933 496 716 MVA</div>
<div class="movie">Gavekort kr ${verdi}</div>
${qrMarkup}
<div class="id">${ticketId}</div>
<div class="utloper">Gyldig til ${expiresTs}</div>
`;
}

// returkvittering
let markupRefundReciept = function (params) {
    /* type, ordreid, kasseid, date, num_tickets, sum */
    let retur = '';
    if (params.type === 'cash' || params.type === 'kort') {
        retur = fmtMoney(params.sum)
    } else {
        retur = `${params.num_tickets} tilgodebillett${(params.num_tickets === 1 ? '' : 'er')}`;
    }
    return `<div class="kvittering">
    <h2>Returkvittering</h2>
    <div class="sentrert">Bygdekinoen</div>
    <div class="sentrert">Org.nr. 933 496 716 MVA</div>
    <div class="sentrert">Ordre #${(params.ordreid || 0)}, Kasse#${(params.kasseid || 0)}</div>
    <div class="sentrert">${fmtDateTime(params.date)}</div>
    <div class="row strekover">
        <div>${params.num_tickets} billett${(params.num_tickets === 1 ? '' : 'er')}</div>
    </div>
    <div class="row strekover">
        <div>Tilbake${params.type === 'kort' ? ' til kort' : ''}</div>
        <div>${retur}</div>
    </div>
</div>
`;
}

let markupReciept = function (params, isCopy = false) {
    let title, produktliste;
    if (params.ordre.trans.filter(trans =>
        trans.betalingstype === 'faktura' &&
        trans.er_korrigert !== true &&
        trans.er_korreksjon !== true).length
    ) {
        if (isCopy) {
            title = 'Kopi av utleveringskvittering';
        } else {
            title = 'Utleveringskvittering - ikke kvittering for salg';
        }
    } else if (isCopy) {
        title = 'Kopi av salgskvittering';
    } else {
        title = 'Salgskvittering';
    }
    if (params.ordre.gavekort && params.ordre.gavekort.length) {
        let sum = 0;
        params.ordre.gavekort.map(gk => {
            sum += gk.verdi;
        });
        produktliste = params.ordre.gavekort.length + ` gavekort ` + fmtMoney(sum);
    } else {
        const produkter = ordreToProduktliste(params.ordre);
        produktliste = produkter.map( produkt => {
            if (produkt.info) {// norgesbillett
                return `<div class="row"><div>${produkt.label}</div><div>${produkt.info}</div></div>`;
            } else if (produkt.sum) {// normal & kampanje
                return `<div class="row"><div>${produkt.label}</div><div>${fmtMoney(produkt.sum)}</div></div>`;
            } else {// ledsager/stab
                return `<div class="row"><div>${produkt.label}</div><div>&nbsp;</div></div>`;
            }
        }).join('\n');
    }

    // Kampanje-rabatt
    const rabatt = ordreToRabatter(params.ordre);
    if (rabatt) {
        produktliste += '\n'+`<div class="row"><div>Rabatt totalt</div><div>${fmtMoney(rabatt)}</div></div>`;
    }

    // finn ikke-korrigerte gavekortbetalinger og regn ut saldo
    const gk = params.ordre.trans.filter(trans =>
        trans.betalingstype === 'gavekort' &&
        trans.er_korreksjon !== true &&
        trans.er_korrigert !== true
    );
    let gavekortsaldo;
    if (gk.length) {
        let saldo = gk.reduce((saldo, trans) => saldo + trans.betaling_info.rest_verdi - trans.belop, 0);
        gavekortsaldo = `<div class="row luftover">
            <div>Gavekort-saldo</div>
            <div>${fmtMoney(saldo)}</div>
        </div>`;
    } else {
        gavekortsaldo = '';
    }

    const transaksjoner = params.ordre.trans.filter(
        t =>
            t.betalingstype !== 'kampanje' &&
            t.betalingstype !== 'norgesbillett' &&
            t.betalingstype !== 'ledsager' &&
            t.betalingstype !== 'stab' &&
            t.betalingstype !== 'fribillett'
    );

    // vis veksel (når relevant)
    let tilbake = '';
    if (params.ordre.trans) {
        const betalt = transaksjoner.reduce((total, trans) => total + trans.belop, 0);
        if (betalt > params.ordre.sum_betalt) {
            tilbake = `<div class="row">
            <div>Tilbake</div>
            <div>${fmtMoney(betalt - params.ordre.sum_betalt)}</div>
        </div>
`;
        }
    }


    return `<div class="kvittering">
    <div class="sentrert">
        <svg id="bk-logo" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 781.66 119.49"><path id="RULL" d="M180.65,84.85l.32-42a78,78,0,0,0-12.38-10.49C161.65,27.61,150.83,22,138.72,22s-22.92,5.65-29.87,10.39A78,78,0,0,0,95.47,44.08V74.54a63.77,63.77,0,0,0,11.46,9.18c6.42,4.06,16.61,8.9,28.68,8.9,7.82,0,13.77-2,17.69-5.9a15.21,15.21,0,0,0,4.5-10.13V66.91A70.57,70.57,0,0,1,177.35,81.3Zm-27-8.3c0,.49-.2,11.94-18.09,11.94-18.26,0-32.09-11.87-36-15.68V48.05a77.16,77.16,0,0,0,9.38,6.69c7,4.26,17.74,9.26,29.8,9.26,6.63-.14,11.53-2.5,15-7.15Zm-1-33.18c2,8.24-3.78,13.33-6.61,14.86V45.47l-.68,1.23a8.59,8.59,0,0,1-2.89,2.86,7.32,7.32,0,0,1-3.79,1,7.75,7.75,0,0,1-7.74-7.75,8.74,8.74,0,0,1,7.59-8.55c3.71-.33,10.41.21,13.61,7.51.16.41.31.82.43,1.24h0Zm-14,11.27a11.81,11.81,0,0,0,3.54-.57l-.05,5.42a25.33,25.33,0,0,1-6.33.34,35.12,35.12,0,0,1-5-.67V51.61a11.72,11.72,0,0,0,7.87,3Zm37.93,20.2A72.36,72.36,0,0,0,157.8,62.4V54.73c0-.39.31-9.58-1.89-14.6-3.08-7.05-9.54-10.68-17.71-10a13,13,0,0,0-11.41,12.6V58.2c-12.27-3.41-21.87-10.87-25.72-14.2,4.66-4.55,19.91-17.94,37.65-17.94,18.23,0,33.68,14,38.13,18.41Z"/><path d="M216.73,33.66h26.85c7.7,0,14.51,4.49,14.51,13.47a10.57,10.57,0,0,1-6.17,10,12.3,12.3,0,0,1,9,12.26c0,9-6.66,14.59-15.47,14.59h-28.7ZM226,53.78h16.51c4.09,0,6.25-2.64,6.25-5.69s-2.16-5.61-6.25-5.61H226Zm0,21.4h18.35c4.17,0,7.22-2.72,7.22-6.25s-3-6.33-7.22-6.33H226Z"/><path d="M388.45,79.27h-.16C385.64,82.8,380.83,85,375.54,85c-12.74,0-20.12-10.42-20.12-20.44,0-9.54,7.94-20.44,20.52-20.44,5.77,0,10.18,2.49,12.35,5.77h.16V33.66h8.33V84h-8.33Zm-11.87-2.08a12.59,12.59,0,1,0-12.34-12.84v.25a12.48,12.48,0,0,0,12.34,12.59Z"/><path d="M444.57,75.58c-4.65,5.85-11.07,9.38-18,9.46-13.55,0-21.4-10.18-21.4-20.44s7.85-20.44,21.4-20.44c8.09,0,20.12,6.66,20.12,21.81v1.52H414.42c.49,5.93,6,10.18,11.87,10.18,4.49,0,8.33-2.17,11.22-6Zm-7.7-15c-1.77-5.93-6.17-9-11.46-9s-9.62,3.28-11,9Z"/><path d="M453.07,33.66h8.33V60h4.25l10.18-14.8h10.1L472.79,63.48,486.57,84h-9.85L466.45,67.81H461.4V84h-8.33Z"/><path d="M497.8,32.11a4.65,4.65,0,1,1-4.65,4.65h0A4.65,4.65,0,0,1,497.8,32.11ZM493.63,45.2H502V84h-8.34Z"/><path d="M512.71,45.2h8.34v4.89h.16c2.32-3.6,6.57-5.93,11.86-5.93,8.18,0,15.07,6.82,15.07,16.43V84h-8.33V62.44c0-7.06-3.69-9.94-9.22-9.94-5.37,0-9.54,3.45-9.54,9.78V84h-8.34Z"/><path d="M575.64,44.16c13.55,0,21.41,10.18,21.41,20.44S589.19,85,575.64,85s-21.4-10.18-21.4-20.44S562.1,44.16,575.64,44.16Zm0,33a12.59,12.59,0,1,0-12.58-12.6v0a12.36,12.36,0,0,0,12.13,12.59h.45Z"/><path d="M641.94,75.58c-4.65,5.85-11.06,9.38-18,9.46C610.36,85,602.5,74.86,602.5,64.6s7.86-20.44,21.41-20.44C632,44.16,644,50.82,644,66v1.52H611.8c.48,5.93,6,10.18,11.86,10.18,4.49,0,8.34-2.17,11.23-6Zm-7.69-15c-1.77-5.93-6.18-9-11.47-9s-9.62,3.28-11,9Z"/><path d="M650.76,45.2h8.34v4.89h.16c2.33-3.6,6.57-5.93,11.86-5.93,8.18,0,15.07,6.82,15.07,16.43V84h-8.33V62.44c0-7.06-3.69-9.94-9.22-9.94-5.37,0-9.54,3.45-9.54,9.78V84h-8.34Z"/><path d="M349.32,45.2h-7.85v4.57h-.16c-2.73-3.6-6.9-5.61-12.11-5.61-10.34,0-19.8,7.3-19.8,20,0,12.27,8.82,19.8,18.84,19.8a16.57,16.57,0,0,0,13.23-6v8.12c-.23,6.41-4.83,9.61-10.15,9.69H318.11v7.84h13.51c7.21,0,17.71-5.21,17.71-17.08ZM329.93,76.14c-7.06,0-11.71-5.37-11.71-12.1a11.63,11.63,0,0,1,23.25-.6c0,.23,0,.45,0,.68C341.47,70.77,336.66,76.14,329.93,76.14Z"/><path d="M303.71,45.2h-8.34v22c0,6-3.13,10-9.62,10-5.13,0-9.14-2.73-9.14-9.22V45.2h-8.33V67.65C268.28,78.55,275.33,85,284,85c5.37,0,8.41-1.6,11.7-5.29h.16v5.88h0c0,6.74-4.7,10.1-10.15,10.18H272.46v7.84H286c7.21,0,17.74-5.21,17.74-17.07Z"/></svg>
    </div>
    <h2>${title}</h2>
    <div class="sentrert">Bygdekinoen</div>
    <div class="sentrert">Org.nr. 933 496 716 MVA</div>
    <div class="sentrert">Ordre #${(params.ordre.ordreid || 0)}, Kasse#${(params.ordre.kasse || 0)}</div>
    <div class="ordre-qr">${params.ordre.qrSVG}</div>
    <div class="id sentrert">${fmtUUID(params.ordre.uuid)}</div>
    <div class="sentrert">${fmtDateTime(params.ordre.ordredato)}</div>
    <div class="strekover">
        ${produktliste}
    </div>
    <div class="row small luftunder luftover">
        <div>MVA (av totalt kr ${fmtMoney(params.ordre.sum)})</div>
        <div>${fmtMoney(params.ordre.heravmva)}</div>
    </div>
    <div class="row heading">Betalinger</div>
    ` + transaksjoner.map(
        trans => `    <div class="row small">
        <div>${fmtPaymentType(trans.betalingstype)}</div>
        <div>${fmtMoney(trans.belop)}</div>
    </div>`
    ).join('\n') + `
    <div class="row strekover">
        <div>Totalt</div>
        <div>${fmtMoney(params.ordre.sum_betalt)}</div>
    </div>
    ${tilbake}
    ${gavekortsaldo}
</div>
`;
}

// *****************************************************************
// X/Z-Rapport-markup-generator
// MIDLERTIDIG til vi får dataene som et ARRAY av rader fra backend
// *****************************************************************
const css_report = `
    html, body { font-size: 10pt; }
    h3 { text-align: center; }
    .sentrert { text-align: center; }
    table { width: 100%; }
    .right, td:nth-child(2) {
      text-align: right;
    }
    tr.kasse-id td {
        border-bottom: 1px dashed black;
    }
    tr.kontant td {
        border-top: 1px dashed black;
        font-weight: bold;
    }
    tr.strek td {
        border-top: 1pt dashed black;
        height: 1pt;
    }
`;

export const markupReport = function (data) {
    if (data instanceof Array) {
        return _markupReportNew(data);
    } else {
        console.error('unsupported format');
    }
}

export const printReport = function (data) {
    print(
        markupPage(markupReport(data), css_page_base + css_report)
    )
}

const _markupReportNew = function (rows) {
    const title = rows[0];
    return `
    <h3>${title}</h3>
    <table>
    ${rows.slice(1).map(row => {
        if (row.length === 1) {
            if (row[0] === '-') { // strek
                return '        <tr class="strek"><td colspan="2"></td></tr>';
            } else { // 'overskrift'
                return `        <tr><td colspan="2">${row[0]}</td></tr>`;
            }
        } else if (row.length === 2) {
            return `        <tr><td>${row[0]}</td><td>${row[1]}</td></tr>`;
        } else {
            return `<!-- NULL-RAD? -->`;
        }
    }).join('\n')}
    </table>
`;
}

export const printBesoksrapport = function (data) {
    print(
        markupPage(_markupBesoksrapport(data), css_page_base + css_besok)
    );
}

const css_besok = `
    html, body { font-size: 10pt; }
    h3 { text-align: center; }
    p {margin: 0;}
    .forestilling {
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .salg {display: flex;}
    .salg .label {flex: 1;}
    .salg .antall { padding-right: 10px; text-align: right; }
    .salg.totalt {font-weight: bold;}
    .strek {
        display: block;
        width: 90%;
        margin: auto;
        margin-top: 4em;
        margin-bottom: 0.2em;
        border-bottom: 2px dashed black;
    }
    .sign { text-align: center; }
`;

const _markupBesoksrapport = function (data) {
    // data = { dato, spillested, maskinist, forestillinger }
    return `
    <h3>Besøksrapport</h3>
    <p>${fmtDate(data.dato)}</p>
    <p>${data.spillested.navn}, ${data.spillested.stedsnavn}</p>
    <p>${data.maskinist.fornavn} ${data.maskinist.etternavn}</p>
` + data.forestillinger.map(forestilling => `
    <div class="forestilling">
        <span class="film">${forestilling.tidspunkt}
        ${[forestilling.film.norsktittel, forestilling.film.version_subtitle || ''].join(' ')}</span>
        <div class="salg">
            <span class="label">Antall på nett: </span><span class="antall">${forestilling.n_per_ordretype.nett || 0}</span>
        </div>
        <div class="salg">
            <span class="label">Antall i kasse: </span><span class="antall">${forestilling.n_per_ordretype.luke || 0}</span>
        </div>
        <div class="salg totalt">
            <span class="label">Totalt antall solgte billetter: </span><span class="antall">${forestilling.n_solgt || 0}</span>
        </div>
    </div>
`).join('\n') + `
    <p>Godkjent på spillestedet</p>
    <p class="strek"></p>
    <p class="sign">Signatur</p>
`;

}



/***** Månedsrapport for nettsalget ****/

const css_nettsalg = `
    html, body {
        font-size: 13pt;
    }
    .report__nettsalg {
        margin: 10mm auto;
        max-width: 190mm;
        width: 98%;
    }
    .nettsalg__sale-total {
        display: flex;
        font-weight: bold;
        margin: 10mm 0 2mm 0;
    }
    .nettsalg__sale-total-value {
        flex: 1 1 50%;
    }
    .nettsalg__mva-list {
        display: flex;
        font-weight: bold;
        margin: 2mm 0 10mm 0;
    }
    .nettsalg__mva-info {
        flex: 1 1 50%;
    }
    .nettsalg__forestillinger {
        border-top: 2pt solid grey;
        margin-top: 5mm;
        padding-top: 5mm;
    }
    .nettsalg__forestilling-item {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5mm;
    }
    .forestilling__sale {
        white-space: nowrap;
    }
`;

export function printNettsalgrapport(data) {
    print(markupPage(markupNettsalgrapport(data),
        css_page_base + '\n' + css_nettsalg))
}

export const markupNettsalgrapport = function (data) {
    // console.log('Nettsalgrapportdata', data);
    const brutto_pr_type = [];
    for (let type of Object.keys(data.brutto_per_bettyp)) {
        brutto_pr_type.push({
            type: fmtPaymentType(type),
            sum: fmtMoney(data.brutto_per_bettyp[type])
        });
    }
    const mva_pr_kode = [];
    for (let item of Object.values(data.mvabelop)) {
        mva_pr_kode.push({
            kode: item.mvakode,
            sats: item.sats,
            belop: fmtMoney(item.mva_belop.toString())
        });
    }
    const forestillinger = [];
    for (let f of Object.values(data.forestillinger)) {
        forestillinger.push({
            sted: f.spillested.stedsnavn,
            dato: fmtDateFromDateTime(f.dato),
            film: f.forestilling.film.norsktittel,
            antall: f.ant_bill_i_per,
            brutto: fmtMoney(f.brutto_salg_i_per)
        });
    }

    return `
    <section class="report__nettsalg">
        <h3>Månedsrapport ${fmtDateFromDateTime(data.from)} – ${fmtDateFromDateTime(data.to)}</h3>
        <div>
            <div class="nettsalg__sale-total">
                <div class="nettsalg__sale-total-value">
                    <p>Totalt salg brutto:</p>
                    <p>${fmtMoney(data.tot_brutto.toString())} kr</p>
                </div>
                <div class="nettsalg__sale-total-value">
                    <p>Totalt salg netto:</p>
                    <p>${fmtMoney(data.tot_netto.toString())} kr</p>
                </div>
            </div>
            <div class="nettsalg__mva-list">
                ${mva_pr_kode.map(item =>
        `<div class="nettsalg__mva-info">
            <p>Mva ${item.sats}%</p><p>${item.belop} kr</p>
        </div>`
    ).join('\n')
        }
            </div>
            <div>${brutto_pr_type.map(item =>
            `<p><b>${item.type}:</b> ${item.sum}</p>`
        ).join('\n')
        }</div>
            <div class="nettsalg__forestillinger">
                <h5>Forestillinger:</h5>
                ${forestillinger.map(f =>
            `<div class="nettsalg__forestilling-item">
                            <span>${f.dato} ${f.sted} - ${f.film}:</span>
                            <span class="forestilling__sale">${f.antall} billetter / ${f.brutto} kr</span>
                        </div>`
        ).join('\n')
        }
            </div>
        </div>
    </section>
    `;
}

/*------ Kunderapport per forestilling ---------------*/

const css_kundeliste = `
    html, body {
        font-size: 11pt;
    }
    .report__kundeliste {
        margin: 10mm auto;
        max-width: 200mm;
        width: 98%;
    }
    .forestilling__info {
        margin-bottom: 1.5em;
    }
    .kundeliste {
        border-top: 1px solid gray;
    }
    .kundeliste__ordrelinje {
        border-bottom: 1px solid gray;
        display: flex;
        justify-content: space-between;
    }
`;

export function printKundeliste(data, forestillingsdata) {
    print(markupPage(markupKundeliste(data, forestillingsdata),
        css_page_base + '\n' + css_kundeliste))
}

export const markupKundeliste = function (data, forestillingsdata) {
    return `
        <section class="report__kundeliste">
            <h3>Kundeliste for forestilling ${forestillingsdata.forestilling.id}</h3>
            <p class="forestilling__info"> ${forestillingsdata.spillested.stedsnavn} <br />${fmtDate(forestillingsdata.ruteplan.dato)} kl ${forestillingsdata.forestilling.tidspunkt}: <i>${forestillingsdata.film_tittel}</i></p>
            <p>Inkluderer refunderte billetter</p>
            <div class="kundeliste">
                ${(data.length === 0 ? "Ingen billetter" : "")}
                ${data.map(d =>
        `<div class="kundeliste__ordrelinje">
            <p class="kundeliste__kontaktinfo">
                <span>${d.kundeinfo.navn}, </span>
                <span>${(d.kundeinfo.epost ? d.kundeinfo.epost + ', ' : '')}</span>
                <span>${(d.kundeinfo.telefon ? d.kundeinfo.telefon : '')}</span>
            </p>
            <div><p>${d.antall} billett${(d.antall > 1 ? "er" : "")}</p></div>
        </div>`
    ).join('\n')
        }
            </div>
            
        </section>
    `;
}

/***** Diverse formateringshjelp *****/

// 2020-02-01 -> 01.02.2020
const fmtDate = function (date) {
    let [y, m, d] = date.split('-');
    return `${d}.${m}.${y}`;
}

// '2020-02-01T03:04:05.12345' -> '01.02.2020 03:04:05'
const fmtDateTime = function (datetime) {
    let [date, time] = datetime.split('T');
    return fmtDate(date) + ' ' + time.split('.')[0];
}

// '2020-02-01T03:04:05.12345' -> '01.02.2020'
const fmtDateFromDateTime = function (datetime) {
    return fmtDate(datetime.split('T')[0]);
}


// De første 16 tegna fra uuid-en
const fmtUUID = function (uuid) {
    return uuid.substr(0, 16);
}

// Mapping fra backendnavn til publikumsvennlig versjon
export const fmtPaymentType = function (type) {
    return ({
        'cash': 'Kontant',
        'kortterminal': 'Kort',
        'norgesbillett': 'Norgesbillett',
        'kampanje': 'Kampanjebillett',
        'stab': 'Stabsbillett',
        'ledsager': 'Ledsager',
        'tilgodelapp': 'Tilgodebillett',
        'tilgodebillett': 'Tilgodebillett',
        'vipps': 'Vipps (Nett)',
        'vipps_kasse': 'Vipps (Kasse)',
        'fribillett': 'Fribillett'
    }[type] || fmtTitlecase(type));
}

// bla -> Bla
const fmtTitlecase = function (str) {
    return str.charAt(0).toUpperCase() + str.substr(1)
}

// skjøter på ',00' på beløp eller skriver om punktum til komma - hackish
const fmtMoney = function (value) {
    if (typeof (value) === 'string') {
        return value.split('.').join(',');
    } else {
        return value + ',00';
    }
}

// Grammatisk korrekt produktnavn
export const fmtProduktnavn = function (type, plural = false) {
    return {
        'kampanje': ['Kampanjebillett', 'Kampanjebilletter'],
        'norgesbillett': ['Norgesbillett', 'Norgesbilletter'],
        'ledsager': ['Ledsagerbillett', 'Ledsagerbilletter'],
        'normal': ['Billett', 'Billetter'],
        'stab': ['Stabsbillett', 'Stabsbilletter'],
        'fribillett': ['Fribillett', 'Fribilletter']
    }[type][plural ? 1 : 0];
}

// Generer produktliste hvor vanlige-, ledsager- og stab-billetter slås sammen til en linje
// 'normal', 'ledsager', 'stab', 'norgesbillett', 'kampanje'
export const ordreToProduktliste = function (ordre/* : Ordre */, skipRabatter=false) {
    const produkter = [];
    const grouped = groupBilletterByType(ordre.billetter);
    if (grouped.normal) {
        produkter.push(tallyBilletter(grouped.normal));
    }
    if (grouped.ledsager) {
        const ledsager = tallyBilletter(grouped.ledsager);
        ledsager.sum = 0;
        produkter.push(ledsager);
    }
    if (grouped.stab) {
        const stabs = tallyBilletter(grouped.stab);
        stabs.sum = 0;
        produkter.push(stabs);
    }
    if (grouped.norgesbillett) {
        for (const billett of grouped.norgesbillett) {
            produkter.push({
                label: 'Norgesbillett',
                info: billett.billettinfo,
                billetter: [billett]
            });
        }
    }
    if (grouped.kampanje) {
        for (const b of grouped.kampanje) {
            produkter.push({
                label: b.kampanjebeskrivelse || 'Kampanjebillett',
                billetter: [b],
                sum: b.belop
            });
        }
    }
    if (grouped.fribillett) {
        for (const b of grouped.fribillett) {
            produkter.push({
                label: 'Fribillett' + (b.fribillett_nummer ? ' ' + b.fribillett_nummer : ''),
                billetter: [b],
                sum: 0
            });
        }
    }
    return produkter;
}

const ordreToRabatter = function(ordre) {
    const billetter = ordre.billetter.filter( b => b.billetttype === 'kampanje' );
    const total = billetter.reduce((sum, b) => sum + b.rabatt_ink, 0);
    return total;
}

// gruppér billetter på billetttype - {type: [billett, ...], ...}
const groupBilletterByType = function (billetter) {
    const byType = {};
    billetter.forEach(billett => {
        const type = billett.billetttype;
        if (!byType[type]) {
            byType[type] = [billett];
        } else {
            byType[type].push(billett);
        }
    });
    return byType;
}

// Tell og summér billetter (de bør ha samme billetttype for at resultatet skal gi mening)
const tallyBilletter = function (billetter/* : Array<Billett> */) {
    const count = billetter.length;
    if (count) {
        return {
            label: count + ' ' + fmtProduktnavn( billetter[0].billetttype, count !== 1 ),
            sum: billetter.reduce((sum, b) => sum + b.belop, 0),
            billetter: billetter
        }
    } else {
        return { label: '', sum: 0, billetter: [] }
    }
}
